import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { Reducers } from '../reducers';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: [
        'dataPvState',
        'pedidoState',
        'dataPedido',
        'dataFaccao',
        'capacidadeState',
        'indiceQualidadeState',
        'somatorioState',
        'loadState',
        'factionFilters',
    ],
};

const persistedReducer = persistReducer(persistConfig, Reducers);
const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

const store = createStore(persistedReducer, devTools);
const persistor = persistStore(store);
window.store = store;
export { store, persistor };
